import { closeModalAnalytics } from "@/utils/helper"

export const addReviewClickAnalytics = () => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "pdp:review ratings:stars click",
    eventName: "pdp:review ratings:stars click",
    eventType: "interaction",
    internalLinkName: "review stars",
    internalLinkPosition: "pdp",
    internalLinkType: "pdp:ratings:stars",
    internalLinkZoneName: "pdp:review section",
    internalLinkURL: "n/a",
  }
  window.adobeDataLayer.push({
    event: "cmp:click",
    page,
    eventInfo,
  })
}

export const reviewFieldClickAnalytics = name => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `review modal:review ${
      name === "review" ? "field" : "title"
    } click`,
    eventName: `review modal:review ${
      name === "review" ? "field" : "title"
    } click`,
    eventType: "interaction",
    internalLinkName: `review ${name === "review" ? "field" : "title"}`,
    internalLinkPosition: "review modal",
    internalLinkType: "modal:review",
    internalLinkZoneName: "review modal",
    internalLinkURL: "n/a",
  }
  window.adobeDataLayer.push({
    event: "cmp:click",
    page,
    eventInfo,
  })
}

export const closeReviewModalAnalytics = () => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "review modal:close button click",
    eventName: "review modal:close button click",
    eventType: "interaction",
    internalLinkName: "close button",
    internalLinkPosition: "review modal",
    internalLinkType: "modal:close",
    internalLinkZoneName: "review modal",
    internalLinkURL: "n/a",
  }
  window.adobeDataLayer.push({
    event: "cmp:click",
    page,
    eventInfo,
  })
}

export const submitReviewAnalytics = () => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "review modal:submit cta click",
    eventName: "review modal:submit cta click",
    eventType: "interaction",
    internalLinkName: "submit cta",
    internalLinkPosition: "review modal",
    internalLinkType: "modal:cta",
    internalLinkZoneName: "review modal",
    internalLinkURL: "n/a",
  }
  window.adobeDataLayer.push({
    event: "cmp:click",
    page,
    eventInfo,
  })
}

export const closeSuccessReviewModalAnalytics = () => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: "review success message:close click",
    eventName: "review success message:close click",
    eventType: "interaction",
    internalLinkName: "success message close",
    internalLinkPosition: "review modal",
    internalLinkType: "modal:message",
    internalLinkZoneName: "review modal",
    internalLinkURL: "n/a",
  }
  window.adobeDataLayer.push({
    event: "cmp:click",
    page,
    eventInfo,
  })
}
